<template>
    <div>
        <div v-if="show===0" style="margin:auto;padding-top: 10px">
            <v-tabs style="background-color: #00a650" dark
                    v-model="selectedTab">
                <v-tab key="sentExercise" @click="getPost"
                       v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                    Bài tập đã giao
                </v-tab>
                <v-tab key="unsentExercise" @click="getUnsentPost"
                       v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                    Bài tập chưa giao
                </v-tab>
                <v-tabs-items v-model="selectedTab">
                    <v-tab-item key="sentExercise"
                                v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                        <v-data-table :headers="exerciseHeaders" :items="posts" :total-items="postCount"
                                      :pagination.sync="pagination"
                                      @update:pagination="getPost"
                                      class="elevation-1"
                        >
                            <template slot="items" slot-scope="props">
                                <td>{{ props.index+1 + parseInt(pagination.page-1) *
                                    parseInt(pagination.rowsPerPage)}}</td>
                                <td width="70%" style="padding: 10px">
                                    <div class="primaryColor title" style="margin-top: 10px;margin-bottom: 10px">
                                        {{props.item.title}}
                                    </div>
                                    <div>Hình thức: {{getExerciseType(props.item.objectType)}}</div>
                                </td>
                                <td>{{props.item.numberOfQuiz}}</tD>
                                <td>{{props.item.questionTime}}</tD>
                                <td>{{props.item.createdAt | formatDateTime}}</tD>
                                <td>{{props.item.dueDate | formatDate}}</tD>
                                <td style="text-align: center;">
                                    <img src="../../../public/img/yolearn_logo.png" width="30px" v-if="props.item.source==1"/>
                                    <img src="../../../public/img/logo_green.png" width="30px" v-else/>
                                </td>
                                <td>
                                    <v-btn flat dark color="primary" @click="onEdit(props.item)">
                                        <v-icon>check</v-icon>
                                        <label>Chọn</label>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item key="unsentExercise"
                                v-if="$store.state.auth.user.role == 1 || $store.state.auth.user.role == 4">
                        <v-data-table :headers="exerciseHeaders" :items="notSendPost" :total-items="notSendPostCount"
                                      :pagination.sync="unSentPagination" @update:pagination="getUnsentPost"
                                      class="elevation-1"
                        >
                            <template slot="items" slot-scope="props">
                                <td>{{ props.index+1 + parseInt(unSentPagination.page-1) *
                                    parseInt(unSentPagination.rowsPerPage)}}</td>
                                <td width="70%" style="padding: 10px">
                                    <div class="primaryColor title" style="margin-top: 10px;margin-bottom: 10px">
                                        {{props.item.title}}
                                    </div>
                                    <div>Hình thức: {{getExerciseType(props.item.objectType)}}</div>
                                </td>
                                <td>{{props.item.numberOfQuiz}}</tD>
                                <td>{{props.item.questionTime}}</tD>
                                <td>{{props.item.createdAt | formatDateTime}}</tD>
                                <td>{{props.item.dueDate | formatDate}}</tD>
                                <td style="text-align: center;">
                                    <img src="../../../public/img/yolearn_logo.png" width="30px" v-if="props.item.source==1"/>
                                    <img src="../../../public/img/logo_green.png" width="30px" v-else/>
                                </td>
                                <td>
                                    <v-btn flat dark color="primary" @click="onEdit(props.item)">
                                        <v-icon>check</v-icon>
                                        <label>Chọn</label>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
        <div v-else-if="show === 1">
            <essay-create @onCancelCreate="showList" :class-id="classId" :question="essayQuestion"
                          class="flex xs12 sm12 md12 lg10 xl8" style="margin:auto"/>
        </div>
        <div v-else-if="show === 2">
            <quiz-create @onCancelCreate="showList" :class-id="classId" :question="quizQuestion" :source="source"/>
        </div>
    </div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import Post from "./post";
    import EssayCreate from "./essayQuestion";
    import QuizCreate from "./quizQuestion";
    import TeacherViewQuestion from "./teacherViewQuestion";
    import StudentViewQuestion from "./studentViewQuestion";
    import MatrixPage from "./matrix/matrixPage";
    import moment from "moment";

    export default {
        components: {
            MatrixPage,
            StudentViewQuestion, TeacherViewQuestion, QuizCreate, EssayCreate, Post, TeacherInfo, ClazzCreate
        },
        props: {
            objectType: {
                type: String | Number,
                default: 0
            },
            classId: {
                type: String | Number,
                default: null
            },

        },

        watch: {
            classId: function (data) {
                this.getPost();
            }
        },

        computed: {
            styleOfFeed: function () {
                if (this.editting) {
                    return "feed active";
                } else {
                    return "feed";
                }
            },

            backgroundStyle: function () {
                if (this.editting) {
                    return "background show";
                } else {
                    return "background";
                }
            }
        },

        data() {
            return {
                activeTab: 0,
                selectedTab: null,
                show: 0,
                cl: {},
                source: 0,
                question: {},
                questionType: null,
                essayQuestion: {},
                quizQuestion: {},
                postCount: 0,
                posts: [],
                notSendPostCount: 0,
                notSendPost: [],
                editingPost: {},
                media: [],
                user: {},
                content: "",
                title: "",
                postURL: null,
                postId: null,
                parentId: null,
                accept: "video/*,  video/x-m4v, video/webm, video/x-ms-wmv, video/x-msvideo, video/3gpp, video/flv, video/x-flv, video/mp4, video/quicktime, video/mpeg, video/ogv, .ts, .mkv, image/*, image/heic, image/heif",
                fileContent: null,
                fileURL: null,
                fileName: null,
                fileType: null,
                editting: false,
                studentId: null,
                page: 1,
                unsentPage: 1,
                pageSize: 10,
                search: null,
                exerciseHeaders: [
                    {
                        text: "STT",
                        align: "left",
                        search: false,
                        sortable: false,
                        width:"10%",
                        value: "name"
                    },
                    {
                        text: "Tên bài tập",
                        align: "left",
                        sortable: false,
                        search: true,
                        width:"20%",
                        value: "title"
                    },
                    {
                        text: "Số câu",
                        align: "left",
                        sortable: false,
                        search: true,
                        width:"10%",
                        value: "numberOfQuestion"
                    },
                    {
                        text: "Thời gian làm bài",
                        align: "left",
                        sortable: false,
                        search: true,
                        width:"10%",
                        value: "questionTime"
                    },
                    {
                        text: "Ngày tạo",
                        align: "left",
                        sortable: false,
                        search: false,
                        width:"15%",
                        value: "createdAt"
                    },
                    {
                        text: "Hết hạn",
                        align: "left",
                        sortable: false,
                        search: false,
                        width:"15%",
                        value: "dueDate"
                    },
                    {
                        text: "Nguồn đề",
                        align: "left",
                        sortable: false,
                        width:"15%",
                        value: "source"
                    },
                    {
                        text: "Chọn",
                        align: "left",
                        sortable: false,
                        width:"10%",
                        value: "exerciseId"
                    }
                ],
                pagination: {
                    rowsPerPage: 10,
                    page: 1,
                    totalItems: 0,
                    orderBy: 'title',
                    descending: false
                },
                unSentPagination: {
                    rowsPerPage: 10,
                    page: 1,
                    totalItems: 0,
                    orderBy: 'title',
                    descending: false
                },

            }
        },

        created() {
            this.unsubscribe = this.$store.subscribe((mutation, state) => {
                if (mutation.type == "common/setSearch") {
                    this.search = mutation.payload;
                    this.getPost();
                }
            });

            this.user = this.$store.state.auth.user;
            if (this.$route.params.clzz) {
                this.cl = this.$route.params.clzz;
            }
            this.getPost();
            this.interval = setInterval(this.calculateRemainTime, 1000);

        },

        beforeDestroy() {
            this.unsubscribe();
        },

        methods: {

            getExerciseType(type) {
                if (type == 5) {
                    return "Tự luận"
                } else if (type == 6) {
                    return "Trắc nghiệm";
                }
            },

            onEdit: function (item) {
                this.edittingPost = item;
                if (item.objectType == 5) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getEssay?questionId=" + item.objectId).then(
                        data => {
                            data.questionId = null;
                            data.status=0;
                            data.receivers = null;
                            this.essayQuestion = data;
                            ////console.log(this.essayQuestion);
                            this.show = 1;
                        },
                        error => {

                        }
                    )
                } else if (item.objectType == 6) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getQuiz?questionId=" + item.objectId).then(
                        data => {
                            data.questionId = null;
                            data.status=0;
                            data.receivers = null;
                            this.quizQuestion = data;
                            this.show = 2;
                            this.source = 0;
                            ////console.log(this.quizQuestion);
                        }
                    )

                }
            },

            onViewQuestion(question) {
                this.show = 0;
                ////console.log(question);
                this.$nextTick(() => {
                    this.onEdit(this.edittingPost);
                })
            },

            onView: function (item, userId, report) {
                ////console.log(item)
                ////console.log(userId);
                if (item.status == null || item.status == undefined) {
                    let cf = confirm("Bạn có sẵn sàng làm bài tập không?");
                    if (!cf) {
                        return;
                    }
                }
                this.edittingPost = item;
                if (item.objectType == 5) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getEssay?questionId=" + item.objectId).then(
                        data => {
                            this.question = data;
                            this.questionType = item.objectType;
                            this.show = 3;
                            ////console.log(this.show);
                            if (userId != undefined && userId != null && userId != "") {
                                this.studentId = userId;
                            } else {
                                this.studentId = null;
                            }
                            ////console.log(report);
                            if (report == true) {
                                this.$nextTick(
                                    () => {
                                        this.$refs.teacherView.activeReport();
                                    }
                                )
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    )
                } else if (item.objectType == 6) {
                    axios.post(process.env.VUE_APP_API_URL + "/exercise/getQuiz?questionId=" + item.objectId).then(
                        data => {
                            this.question = data;
                            this.questionType = item.objectType;
                            this.show = 3;
                            ////console.log(this.show);
                            if (userId != undefined && userId != null && userId != "") {
                                this.studentId = userId;
                            } else {
                                this.studentId = null;
                            }
                            ////console.log(report);
                            if (report == true) {
                                this.$nextTick(
                                    () => {
                                        this.$refs.teacherView.activeReport();
                                    }
                                )
                            }
                        },
                        error => {
                            //console.log(error);

                        }
                    )

                }
            },

            onViewReport: function (item) {
                axios.post(process.env.VUE_APP_API_URL + "/report/getLessonReport?classId=" + this.classId + "&exerciseId=" + item.objectId + "&exerciseType=" + item.objectType).then(
                    data => {
                        if (data == null || data == "" || data.status != 2) {
                            message.error("Báo cáo chưa có");
                        } else {
                            this.$emit("report", data);
                        }
                    },
                    error => {
                        //console.log(error);
                    }
                )
            },

            onReload: function () {
                this.getPost();
                this.getUnsentPost();
            },

            getPost: function () {
                this.activeTab = 0;
                let page = this.pagination.page;
                let pageSize = this.pagination.rowsPerPage;
                let url = process.env.VUE_APP_API_URL + "/post/onSearchExercise?classId=" + this.classId + "&page=" + page + "&pageSize=" + pageSize;
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.postCount = data.count;
                        this.posts = data.items;
                        ////console.log(this.posts);
                    },
                    error => {

                    }
                )
            },


            getUnsentPost: function () {
                this.activeTab = 1;
                //console.log(this.unSentPagination);
                let page = this.unSentPagination.page;
                let pageSize = this.unSentPagination.rowsPerPage;

                let url = process.env.VUE_APP_API_URL + "/post/onSearchUnsentExercise?classId=" + this.classId + "&page=" + page + "&pageSize=" + pageSize;
                if (this.search != null && this.search != "") {
                    url += "&search=" + this.search;
                }
                axios.post(url).then(
                    data => {
                        this.notSendPostCount = data.count;
                        this.notSendPost = data.items;
                        ////console.log(this.posts);
                    },
                    error => {

                    }
                )
            },

            showList: function () {
                this.show = 0;
                if (this.activeTab == 1) {
                    this.getPost();
                } else {
                    this.getUnsentPost();
                }
            },

            createEssayQuestion: function () {
                //console.log(this.show);
                this.essayQuestion = null;
                this.show = 1;
                //console.log(this.show);
            },

            createQuizQuestion: function () {
                //console.log(this.show);
                this.quizQuestion = null;
                this.show = 2;
                this.source = 0;
                //console.log(this.show);
            },
        }
    };
</script>